import React from "react"

import constants from "utils/constants"
import {
  MainHeaderSection,
  LogoArea,
  HeaderRight,
  LogoImage,
  Title,
  BellLink,
  Alarm,
  BetaWrapper,
  ShopLink,
  IconImg,
} from "./style"
import ToolTip from "components/presenters/common/ToolTip"

import bellIconImg from "images/icon/bell_icon-24x24.png"
import shopIconImg from "images/icon/shop_icon-24x24.png"

const MainHeader = ({
  isLogin,
  newAlarmExist,
  matchingPermission,
  title,
  setTooltipCookies,
  tooltipVisible,
}) => {
  return (
    <>
      <MainHeaderSection>
        <LogoArea>
          {!title ? (
            <>
              <LogoImage
                src={`${constants.imagePath}/common/logo/motiners_logo-364x76.png`}
                alt="motiners logo"
              />
              <BetaWrapper></BetaWrapper>
            </>
          ) : (
            <Title>{title}</Title>
          )}
        </LogoArea>
        <HeaderRight>
          {isLogin ? (
            <>
              {/* <div style={{ position: "relative" }}>
                <ShopLink to={"/motishop"}>
                  <IconImg src={shopIconImg} alt="motiners motishop icon" />
                </ShopLink>
                <ToolTip visible={tooltipVisible} setTooltipCookies={setTooltipCookies} />
              </div> */}

              <BellLink to={`/mypage/setting/alarm`}>
                <IconImg src={bellIconImg} alt="motiners bell icon" />
                {newAlarmExist ? <Alarm></Alarm> : null}
              </BellLink>
            </>
          ) : (
            <>
              {/* <div style={{ position: "relative" }}>
                <ShopLink to={"/motishop"}>
                  <IconImg src={shopIconImg} alt="motiners motishop icon" />
                </ShopLink>
                <ToolTip visible={tooltipVisible} setTooltipCookies={setTooltipCookies} />
              </div> */}
              <BellLink to={`/social`}>
                <IconImg src={bellIconImg} alt="motiners bell icon" />
                {newAlarmExist ? <Alarm></Alarm> : null}
              </BellLink>
            </>
          )}
        </HeaderRight>
      </MainHeaderSection>
    </>
  )
}

export default MainHeader
